<button
  type="button"
  [disabled]="disabled() || loading()"
  [ngClass]="{
    'cursor-default bg-grey-midGrey': disabled() && !loading(),
    'bg-white': !disabled() || loading(),
    'cursor-wait': loading(),
  }"
  class="!inline-flex items-center justify-center rounded-lg border border-grey-midGrey p-1"
  (click)="handleClick()"
  matRipple
  [matRippleDisabled]="disabled()"
>
  @if (loading()) {
    <div class="flex size-full place-content-center rounded-lg">
      <app-loading class="size-6"></app-loading>
    </div>
  } @else {
    <ng-content select="[prepend]"></ng-content>

    <mat-icon
      class="material-icons-outlined inline-flex items-center justify-center xl:!hidden"
      [ngClass]="[leadingIconColor(), leadingIconSize()]"
    >
      {{ leadingIconSM() }}
    </mat-icon>
    <mat-icon
      class="material-icons-outlined !hidden items-center justify-center xl:!inline-flex"
      [ngClass]="[leadingIconColor(), leadingIconSize()]"
    >
      {{ leadingIconXL() }}
    </mat-icon>
    <mat-icon
      class="material-icons-outlined inline-flex items-center justify-center xl:!hidden"
      [ngClass]="[trailingIconColor(), trailingIconSize()]"
    >
      {{ trailingIconSM() }}
    </mat-icon>
    <mat-icon
      class="material-icons-outlined !hidden items-center justify-center xl:!inline-flex"
      [ngClass]="[trailingIconColor(), trailingIconSize()]"
    >
      {{ trailingIconXL() }}
    </mat-icon>
  }
</button>
